export default "__VITE_ASSET__uBvRKyNE__"